import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import "./login.css";

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [turnstileReady, setTurnstileReady] = useState(false);
  const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  useEffect(() => {
    const scriptId = "cf-turnstile-script";
    
    window.onTurnstileSuccess = (token) => setTurnstileToken(token);
    window.onTurnstileExpired = () => setTurnstileToken("");

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.onload = () => {
        // Script ist geladen, Widget sollte jetzt initialisiert werden
        setTurnstileReady(true);
      };
      document.head.appendChild(script);
    } else {
      // Script ist bereits geladen
      setTurnstileReady(true);
    }

    return () => {
      delete window.onTurnstileSuccess;
      delete window.onTurnstileExpired;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (!turnstileToken) {
        setError("Bitte füllen Sie das Captcha aus");
        setLoading(false);
        return;
      }

      await login(username, password, turnstileToken);
    } catch (err) {
      // Turnstile Token resetten nach Fehler
      window.turnstile?.reset();
      setTurnstileToken("");

      // Error-Message basierend auf Fehlertyp
      if (err.message === "CAPTCHA_FAILED") {
        setError("Captcha-Verifikation fehlgeschlagen. Versuchen Sie es erneut.");
      } else if (err.message === "INVALID_CREDENTIALS") {
        setError("Benutzername oder Passwort ist falsch.");
      } else if (err.message === "TOO_MANY_REQUESTS") {
        setError("Zu viele Login-Versuche. Versuchen Sie es in 1 Minute erneut.");
      } else {
        setError("Login fehlgeschlagen. Versuchen Sie es später erneut.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleSubmit}>
        <h2>Login</h2>

        {error && <div className="login-error">{error}</div>}

        <input
          type="text"
          placeholder="Benutzername"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={loading}
          required
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
          required
        />
        <div className="turnstile-wrapper">
          <div
            className="cf-turnstile"
            data-sitekey={turnstileSiteKey || ""}
            data-callback="onTurnstileSuccess"
            data-expired-callback="onTurnstileExpired"
          />
        </div>
        {!turnstileSiteKey && (
          <p className="login-hint">Captcha ist nicht konfiguriert.</p>
        )}
        <button
          type="submit"
          disabled={!turnstileToken || !turnstileSiteKey || loading}
        >
          {loading ? "Wird angemeldet..." : "Einloggen"}
        </button>
      </form>
    </div>
  );
}
